import { http } from '@/core/helpers/http.helper';
export class EmailService {
   async sendMail(emailData: any) {
      const response = await http.post(`/emails/send`, emailData);
      return response.data;
   }

   async getEmail() {
      throw Error('Method not implemented');
   }

   async postEmail() {
      throw Error('Method not implemented');
   }

   async putEmail() {
      throw Error('Method not implemented');
   }

   async deleteEmail() {
      throw Error('Method not implemented');
   }
}
